"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentDialog = void 0;
var react_1 = __importStar(require("react"));
var react_modal_1 = __importDefault(require("react-modal"));
var Actions = __importStar(require("../calendar-actions"));
var appointment_editor_view_1 = require("../../appointment-editor/appointment-editor-view");
var styled_components_1 = __importDefault(require("styled-components"));
var AppointmentEditorState = __importStar(require("../../appointment-editor/appointment-editor-state"));
var graphql_client_1 = require("../../graphql/graphql-client");
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var theme_1 = require("../../theme");
var FormLayout = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  padding: 20px 30px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"], ["\n  background-color: ", ";\n  padding: 20px 30px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.background;
});
var Buttons = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: end;\n  gap: 8px;\n"], ["\n  display: flex;\n  justify-content: end;\n  gap: 8px;\n"])));
var customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        transform: "translate(-50%, -50%)",
        padding: "10px 0 0 0",
        backgroundColor: "".concat(theme_1.calendarTheme.colors.accentDulled),
        border: "1px solid rgba(150, 150, 150, 0.5)",
        borderRadius: "8px",
        boxShadow: "4px 4px 15px ".concat(theme_1.calendarTheme.colors.dropShadow),
    },
    overlay: {
        backdropFilter: "blur(1px)",
        backgroundColor: "rgba(180, 180, 180, 0.4)",
    },
};
function AppointmentDialog(_a) {
    var appointmentEditorState = _a.appointmentEditorState, dispatch = _a.dispatch, requery = _a.requery;
    var graphqlClient = (0, react_1.useContext)(graphql_client_1.GraphqlClientContext);
    return (react_1.default.createElement(react_modal_1.default, { isOpen: true, contentLabel: "Modal", shouldCloseOnOverlayClick: true, onRequestClose: function () { return dispatch(Actions.closeAppointmentDialog()); }, style: customStyles },
        react_1.default.createElement(FormLayout, null,
            react_1.default.createElement(appointment_editor_view_1.AppointmentEditorView, { state: appointmentEditorState, dispatch: function (a) { return dispatch(Actions.dispatchAppointmentEditor(a)); } }),
            react_1.default.createElement(Buttons, null,
                react_1.default.createElement("input", { type: "button", value: "Save", onClick: function () { return saveAppointment({ appointmentEditorState: appointmentEditorState, dispatch: dispatch, requery: requery }, graphqlClient); } }),
                react_1.default.createElement("input", { type: "button", value: "Cancel", onClick: function () { return dispatch(Actions.closeAppointmentDialog()); } })))));
}
exports.AppointmentDialog = AppointmentDialog;
var insertAppointmentMutation = (0, graphql_tag_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  mutation InsertAppointment($input: InsertAppointmentInput!) {\n    insertAppointment(input: $input) {\n      rejected\n    }\n  }\n"], ["\n  mutation InsertAppointment($input: InsertAppointmentInput!) {\n    insertAppointment(input: $input) {\n      rejected\n    }\n  }\n"])));
var updateAppointmentMutation = (0, graphql_tag_1.default)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  mutation UpdateAppointment($input: UpdateAppointmentInput!) {\n    updateAppointment(input: $input) {\n      rejected\n    }\n  }\n"], ["\n  mutation UpdateAppointment($input: UpdateAppointmentInput!) {\n    updateAppointment(input: $input) {\n      rejected\n    }\n  }\n"])));
function saveAppointment(_a, graphqlClient) {
    var appointmentEditorState = _a.appointmentEditorState, dispatch = _a.dispatch, requery = _a.requery;
    return __awaiter(this, void 0, void 0, function () {
        var start, end;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    start = AppointmentEditorState.getStart(appointmentEditorState);
                    end = AppointmentEditorState.getEnd(appointmentEditorState);
                    if (!(appointmentEditorState.appointmentId === undefined)) return [3 /*break*/, 2];
                    return [4 /*yield*/, graphqlClient.runMutation(insertAppointmentMutation, {
                            input: {
                                personId: appointmentEditorState.personId,
                                start: start.valueOf(),
                                end: end.valueOf(),
                                notes: appointmentEditorState.notes,
                            },
                        })];
                case 1:
                    _b.sent();
                    requery();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, graphqlClient.runMutation(updateAppointmentMutation, {
                        input: {
                            appointmentId: appointmentEditorState.appointmentId,
                            personId: appointmentEditorState.personId,
                            start: start.valueOf(),
                            end: end.valueOf(),
                            notes: appointmentEditorState.notes,
                        },
                    })];
                case 3:
                    _b.sent();
                    requery();
                    _b.label = 4;
                case 4:
                    dispatch(Actions.closeAppointmentDialog());
                    return [2 /*return*/];
            }
        });
    });
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=appointment-dialog.js.map